import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';



import { TestComponent} from "./test/test.component";
import {TelecontactComponent} from "./telecontact/telecontact.component";
import {GalleryComponent} from "./gallery/gallery.component";
import {CompaniesComponent} from "./companies/companies.component";
import {ProjectsComponent} from "./projects/projects.component";
import {HcpComponent} from "./hcp/hcp.component";


const routes: Routes = [
  {
    path: 'test',
    component: TestComponent
  },
  {
    path: 'telecontact',
    component: TelecontactComponent
  },
  {
    path: 'gallery',
    component: GalleryComponent
  },
  {
    path: 'companies',
    component: CompaniesComponent
  },
  {
    path: 'hcp',
    component: HcpComponent
  },
  {
    path: 'projects',
    component: ProjectsComponent
  },
  {
    path: '',
    redirectTo: '/projects',
    pathMatch: 'full'
  },
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})




export class AppRoutingModule { }
